<template>
  <div class="signature-pad">
    <p id="signature-help">Firme con el dedo o el mouse dentro del recuadro.</p>
    <canvas
      ref="canvas"
      width="640"
      height="240"
      tabindex="0"
      aria-label="Firma de quien recibe"
      aria-describedby="signature-help"
      @pointerdown="start"
      @pointermove="move"
      @pointerup="end"
      @pointercancel="end"
      :aria-disabled="String(disabled)"
    ></canvas>
    <v-btn flat small :disabled="disabled" @click="clear">Borrar firma</v-btn>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
  data: () => ({ drawing: false, ink: false }),
  methods: {
    point(e) {
      const rect = this.$refs.canvas.getBoundingClientRect()
      return [
        ((e.clientX - rect.left) * 640) / rect.width,
        ((e.clientY - rect.top) * 240) / rect.height,
      ]
    },
    start(e) {
      if (this.disabled) return
      e.preventDefault()
      this.$refs.canvas.setPointerCapture(e.pointerId)
      this.drawing = true
      const ctx = this.$refs.canvas.getContext('2d')
      ctx.strokeStyle = '#172133'
      ctx.lineWidth = 3
      ctx.lineCap = 'round'
      ctx.beginPath()
      ctx.moveTo(...this.point(e))
    },
    move(e) {
      if (!this.drawing) return
      this.ink = true
      const ctx = this.$refs.canvas.getContext('2d')
      ctx.lineTo(...this.point(e))
      ctx.stroke()
    },
    end() {
      this.drawing = false
      this.$emit(
        'input',
        this.ink ? this.$refs.canvas.toDataURL('image/png') : ''
      )
    },
    clear() {
      this.$refs.canvas.getContext('2d').clearRect(0, 0, 640, 240)
      this.ink = false
      this.$emit('input', '')
    },
  },
}
</script>
<style scoped>
.signature-pad p {
  color: #475569;
  margin: 8px 0;
}
canvas {
  display: block;
  width: 100%;
  max-width: 640px;
  height: 180px;
  border: 1px solid #64748b;
  background: #fff;
  border-radius: 8px;
  touch-action: none;
}
canvas:focus-visible {
  outline: 3px solid #254f87;
  outline-offset: 3px;
}
</style>
